import { HeroConfig } from '../types/hero';

export const heroImages: Record<string, HeroConfig> = {
  home: {
    image: "https://images.pexels.com/photos/7567443/pexels-photo-7567443.jpeg",
    overlayOpacity: 0.85,
    position: "center",
  },
  about: {
    image: "https://images.pexels.com/photos/7567455/pexels-photo-7567455.jpeg",
    overlayOpacity: 0.8,
    position: "center",
  },
  deals: {
    image: "https://images.pexels.com/photos/7567455/pexels-photo-7567455.jpeg",
    overlayOpacity: 0.8,
    position: "center",
  },
  learn: {
    image: "https://images.pexels.com/photos/7821528/pexels-photo-7821528.jpeg",
    overlayOpacity: 0.85,
    position: "center",
  },
  community: {
    image: "https://images.pexels.com/photos/7567455/pexels-photo-7567455.jpeg",
    overlayOpacity: 0.8,
    position: "center",
  },
  podcast: {
    image: "https://images.pexels.com/photos/7567616/pexels-photo-7567616.jpeg",
    overlayOpacity: 0.85,
    position: "center",
  },
  membership: {
    image: "https://images.pexels.com/photos/7567619/pexels-photo-7567619.jpeg",
    overlayOpacity: 0.85,
    position: "center",
  }
};